<ng-container *transloco="let t; read: 'configuration'">
<div id="classroom" class="rounded-lg fix-action-row modal-body">
  <div class="flex justify-between border-b">
    <h1 class="text-[25px] font-bold">{{ label }}</h1>
    <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle ml-8"></i>
  </div>

  <div mat-dialog-content>
    <form class="grid md:grid-cols-2 grid-cols-1 gap-4 gap-x-4 p-3 grid-cust" [formGroup]="classroomForm">
      @if (canViewDropdowns) {
        <div class="col-span-1 items-center w-[100%]">
          <drdp-select-state [initialStateId]="selectedState" (state)="handleDropdown($event, selectType.States)"
            [required]="true" [isValid]="!stateId.touched || stateId.valid">
          </drdp-select-state>
        </div>
      }

      @if (canViewDropdowns) {
        <div class="col-span-1 items-center w-[100%]">
          <drdp-select-agency [initialAgencyId]="selectedAgency" (agency)="handleDropdown($event, selectType.Agencies)"
            [stateId]="selectedState" [required]="true" [isValid]="!agencyId.touched || agencyId.valid" [clear]="clearDropdown">
          </drdp-select-agency>
        </div>
      }

      <div class="col-span-1 items-center w-[100%]">
        <label class="font-bold required" for="name">{{ t('common.classroom') }}</label>
        <mat-form-field class="bg-white" appearance="fill">
          <input placeholder="" matInput type="text" formControlName="name" maxlength="100">
        </mat-form-field>
      </div>

      <div class="col-span-1 items-center w-[100%]">
        <drdp-select-site [initialSiteId]="selectedSiteId" [agencyId]="selectedAgency" [required]="true"
          (site)="handleDropdown($event, selectType.Sites)" [isValid]="!siteId.touched || siteId.valid" [clear]="clearDropdown">
        </drdp-select-site>
      </div>
    </form>
  </div>
  <div mat-dialog-actions class="flex justify-end align-bottom">
    <div class="flex justify-end align-bottom">
      <drdp-btn color="cancel" class="mr-2" mat-button mat-dialog-close>{{ t('common.cancel') }}</drdp-btn>
      <drdp-btn type="submit" mat-button (click)="onSubmit()" [disabled]="classroomForm.invalid || isProcessing"
      cdkFocusInitial>{{ t('common.save') }}</drdp-btn>
    </div>
  </div>
</div>
</ng-container>
